import { AloftPrice, PairedSalesAnalysisFeature, StudiesPair } from '@aloft/toolkit-shared';

import { isPairedSalesSqFtFeature } from '../../studies/types.ts';
import { makeSqFtFeatureAdjustResultAndFormulaString } from '../../studies/utils/makeSqFtFeatureAdjustResultAndFormulaString.ts';

export const createPairAdjustmentFormulaString = (
  term: PairedSalesAnalysisFeature,
  pair: StudiesPair,
): string => {
  if (isPairedSalesSqFtFeature(term)) {
    const { formulaString } = makeSqFtFeatureAdjustResultAndFormulaString({
      feature: term,
      pair,
    });
    return formulaString;
  }

  const p1SalePrice = pair.p1.salePrice;
  const p2SalePrice = pair.p2.salePrice;
  const netAdjustments = AloftPrice.addWithNulls(
    AloftPrice.addWithNulls(...Object.values(pair.adjustments)),
  );
  const p2AdjustedValue = p2SalePrice ? AloftPrice.add(p2SalePrice, netAdjustments) : undefined;

  const allDefined = [p1SalePrice, p2SalePrice, p2AdjustedValue, netAdjustments].every(
    AloftPrice.isAloftPrice,
  );

  return allDefined
    ? `${p1SalePrice!.toString(true)} - ${p2AdjustedValue} = ${p1SalePrice!.sub(p2AdjustedValue)}`
    : '';
};
